/**
 * Microsoft smooth streaming.
 */
export const SMOOTH = 'smooth';

/**
 * Apple HTTP Live Streaming.
 */
export const HLS = 'hls';

/**
 * Apple HTTP Live Streaming, Protocol Version 5.
 */
export const HLS5 = 'hls5';

/**
 * Dynamic Adaptive Streaming over HTTP.
 */
export const DASH = 'dash';

/**
 * Microsoft's content protection DASH stream.
 */
export const DASH_WIDEVINE = 'dash_widevine';

/**
 * Google's multiplatform content protection DASH stream.
 */
export const DASH_PLAYREADY = 'dash_playready';

/**
 * Apple HTTP Live Streaming, Protocol Version 5, Fairplay protected
 */
export const HLS5_FAIRPLAY = 'hls5_fairplay';

/**
 * Playready protected Microsoft smooth streaming.
 */
export const SMOOTH_PLAYREADY = 'smooth_playready';

/**
 * Apple HTTP Live Streaming, Protocol Version 7.
 */
export const HLS7 = 'hls7';

/**
 * Apple HTTP Live Streaming, Protocol Version 7, Fairplay protected
 */
export const HLS7_FAIRPLAY = 'hls7_fairplay';
